import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Form } from 'react-final-form';
import { ValidationErrors } from 'final-form';

import { CreateProductCategoryFormRenderComponent } from './CreateProductCategoryFormRenderComponent';

import {
  ProductCategoryFormProps,
  ProductCategoryFormRenderProps,
  ProductCategoryFormValues,
} from '../types';

export interface CreateProductCategoryPageProps {
  createProductCategory: ProductCategoryFormProps['onSubmit'];
  validate?: (values: Partial<ProductCategoryFormValues>) => Promise<ValidationErrors>;
  initialValues: ProductCategoryFormValues;
}

export const CreateProductCategoryPage: React.FC<CreateProductCategoryPageProps> = ({
  validate,
  createProductCategory,
  initialValues,
}) => {
  const renderForm: ProductCategoryFormProps['render'] = React.useCallback(
    ({ handleSubmit, valid, submitting }: ProductCategoryFormRenderProps) => {
      return (
        <CreateProductCategoryFormRenderComponent
          handleSubmit={handleSubmit}
          disabled={!valid || submitting}
        />
      );
    },
    [],
  );

  return (
    <>
      <Helmet>
        <title>Create Product Preference</title>
      </Helmet>
      <Form
        onSubmit={createProductCategory}
        render={renderForm}
        validate={validate}
        initialValues={initialValues}
      />
    </>
  );
};
